import spam from '../assets/challenges/digital/spam.png';
import spam_image_1 from '../assets/challenges/digital/spam_image_1.png';
import spamthurs from '../assets/challenges/digital/spamthurs.png';
import sgfood from '../assets/challenges/food/sgfood/sgfood.png';
import sgfood_image_1 from '../assets/challenges/food/sgfood/sgfood_image_1.png';
import sgfoodtues from '../assets/challenges/food/sgfood/sgfoodtues.png';
import sgrestaurant from '../assets/challenges/food/sgrestaurant/sgrestaurant.png';
import farmtolocal_image_1 from '../assets/challenges/food/sgrestaurant/sgrestaurant_image_1.png';
import vegan_image_1 from '../assets/challenges/food/vegan/vegan_image_1.jpg';
import veganmeal from '../assets/challenges/food/vegan/veganmeal.png';
import veganwed from '../assets/challenges/food/vegan/veganwed.png';
import vegemeal from '../assets/challenges/food/vegetarian/vegemeal.png';
import vegemon from '../assets/challenges/food/vegetarian/vegemon.png';
import vegetarian_image_1 from '../assets/challenges/food/vegetarian/vegetarian_image_1.jpg';
import bag_image_1 from '../assets/challenges/sustainableconsumption/reusableBag/bag_image_1.jpg';
import totebag from '../assets/challenges/sustainableconsumption/reusableBag/totebag.png';
import kitchentowels from '../assets/challenges/sustainableconsumption/reusableTowel/kitchentowels.png';
import towel_image_1 from '../assets/challenges/sustainableconsumption/reusableTowel/towel_image_1.png';
import bus from '../assets/challenges/transport/bus.png';
import bus_image_1 from '../assets/challenges/transport/bus_image_1.png';
import mrt from '../assets/challenges/transport/mrt.png';
import mrt_image_1 from '../assets/challenges/transport/mrt_image_1.jpg';
import aerator_image_1 from '../assets/challenges/utilities/aerator/aerator_image_1.jpg';
import aeratortap from '../assets/challenges/utilities/aerator/aeratortap.png';
import aircon from '../assets/challenges/utilities/aircon/aircon.png';
import aircon_image_1 from '../assets/challenges/utilities/aircon/aircon_image_1.jpg';
import airdry from '../assets/challenges/utilities/airdry/airdry.png';
import airdry_image_1 from '../assets/challenges/utilities/airdry/airdry_image_1.png';
import airdry_image_2 from '../assets/challenges/utilities/airdry/airdry_image_2.png';
import electricityswitch from '../assets/challenges/utilities/electricityswitch/electricityswitch.png';
import electricityswitch_image_1 from '../assets/challenges/utilities/electricityswitch/electricityswitch_image_1.jpg';
import heaterswitch from '../assets/challenges/utilities/heaterswitch/heaterswitch.png';
import heaterswitch_image_1 from '../assets/challenges/utilities/heaterswitch/heaterswitch_image_1.png';

export const categories = [
    'Utilities',
    'Food',
    'Transport', 
    'Sustainable Consumption', 
    'Digital'
];


export const challenges = {
    'u1': {
        title: 'Turn AC to 26 degrees',
        description: 'Upload an image of your AC remote settings to show that the temperature has been set to 26\u00B0C.',
        points: 20,
        headerImg: aircon,
        exampleSubImgs: [aircon_image_1],
        category: 'Utilities',
        day: 'Everyday',
    },
    'u2': {
        title: 'Air dry the clothes',
        description: 'Upload an image of the clothes hung outside on clothes rack.',
        points: 20,
        headerImg: airdry,
        exampleSubImgs: [airdry_image_1, airdry_image_2],
        category: 'Utilities',
        day: 'Everyday',
    },
    'u3': {
        title: 'Turn off electricity socket',
        description: 'Upload an image of a turned-off electrical switch.',
        points: 20,
        headerImg: electricityswitch,
        exampleSubImgs: [electricityswitch_image_1],
        category: 'Utilities',
        day: 'Everyday',
    },
    'u4': {
        title: 'Turn off water heater',
        description: 'Upload an image of a turned-off water heater switch.',
        points: 20,
        headerImg: heaterswitch,
        exampleSubImgs: [heaterswitch_image_1],
        category: 'Utilities',
        day: 'Everyday',
    },
    'u5': {
        title: 'Use aerator heads on taps',
        description: 'Upload an image of aerator heads installed on the tap.',
        points: 50,
        headerImg: aeratortap,
        exampleSubImgs: [aerator_image_1],
        category: 'Utilities',
        // type: 'ota',
        day: 'Everyday',
    },
    'f1': {
        title: 'Vegetarian Monday',
        description: 'Upload a bill or image of the vegetarian meal.',
        points: 100,
        headerImg: vegemon,
        exampleSubImgs: [vegetarian_image_1],
        category: 'Food',
        type: 'weekly',
        frequencyRequired: 4,
        day: 'Monday',
    },
    'f2': {
        title: 'Vegan Wednesday',
        description: 'Upload a bill or image of the vegan meal.',
        points: 100,
        headerImg: veganwed,
        exampleSubImgs: [vegan_image_1],
        category: 'Food',
        type: 'weekly',
        frequencyRequired: 4,
        day: 'Wednesday',
    },
    'f3': {
        title: 'Eat Locally Sourced Food Tuesday',
        description: 'Upload a bill or image of the meal made with locally sourced ingredients.',
        points: 100,
        headerImg: sgfoodtues,
        exampleSubImgs: [],
        category: 'Food',
        type: 'weekly',
        frequencyRequired: 4,
        day: 'Tuesday',
    },
    'f4': {
        title: 'Eat from a sustainable restaurant',
        description: 'Upload a bill or image of restaurant brand item',
        points: 20,
        headerImg: sgrestaurant,
        exampleSubImgs: [farmtolocal_image_1],
        category: 'Food',
        day: 'Everyday',
    },
    'f5': {
        title: 'Eat a vegetarian meal',
        description: 'Upload a bill or image of the vegetarian meal.',
        points: 20,
        headerImg: vegemeal,
        exampleSubImgs: [vegetarian_image_1],
        category: 'Food',
        day: 'Everyday',
    },
    'f6': {
        title: 'Eat a vegan meal',
        description: 'Upload a bill or image of the vegan meal.',
        points: 20,
        headerImg: veganmeal,
        exampleSubImgs: [vegan_image_1],
        category: 'Food',
        day: 'Everyday',
    },
    'f7': {
        title: 'Buy a Locally Sourced Product',
        description: 'Upload a bill or image of the locally sourced product.',
        points: 20,
        headerImg: sgfood,
        exampleSubImgs: [sgfood_image_1],
        category: 'Food',
        day: 'Everyday',
    },
    't1': {
        title: 'Take the bus or MRT',
        description: 'Upload an image of the bus stop or the MRT stop',
        points: 20,
        headerImg: bus,
        exampleSubImgs: [bus_image_1, mrt_image_1],
        category: 'Transport',
        day: 'Everyday',
    },
    't2': {
        title: 'No Car Day (min 2 rides in same day)',
        description: 'Upload an image of the bus stop or the MRT stop',
        points: 50,
        headerImg: mrt,
        exampleSubImgs: [bus_image_1, mrt_image_1],
        category: 'Transport',
        type: 'day',
        frequencyRequired: 2,
        day: 'Everyday',
    },
    'sc1': {
        title: 'Bring your own bag',
        description: 'Upload an image of the reusable bag',
        points: 20,
        headerImg: totebag,
        exampleSubImgs: [bag_image_1],
        category: 'Sustainable Consumption',
        day: 'Everyday',
    },
    'sc2': {
        title: 'Use reusable kitchen towels',
        description: 'Upload an image of the reusable kitchen towel',
        points: 20,
        headerImg: kitchentowels,
        exampleSubImgs: [towel_image_1],
        category: 'Sustainable Consumption',
        day: 'Everyday',
    },
    'd1': {
        title: 'Digital Declutter',
        description: 'Unsubscribe to spam/ newsletter. Upload an image of the empty Spam folder',
        points: 20,
        headerImg: spam,
        exampleSubImgs: [spam_image_1],
        category: 'Digital',
        day: 'Everyday',
    },
    'd2': {
        title: 'Digital Declutter Thursday',
        description: 'Unsubscribe to spam/ newsletter. Upload an image of the empty Spam folder',
        points: 100,
        headerImg: spamthurs,
        exampleSubImgs: [spam_image_1],
        category: 'Digital',
        type: 'weekly',
        frequencyRequired: 4,
        day: 'Thursday',
    },
    // 'xx': {
    //     title: 'sample',
    //     description: 'insertinstructionshere',
    //     points: 10,
    //     headerImg: photo,
    //     exampleSubImgs: [],
    //     category: '',
    //     type: ''
    // },
}